import '../css/loader.css';
import '../App.css';
import '../css/privacy.css';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="loader flex-center">
      <div className="do-stuff-box">
        <div className="input-area privacy">
          <h1>Privacy Policy</h1>
          <p>Last updated: August 19, 2026</p>

          <section>
            <h2>Overview</h2>
            <p>
              Quick Cards uses Google Drive and Google Sheets so you can study flashcards from a spreadsheet
              you choose. This policy explains what Google user data the app accesses, how the app uses that
              data, how the data is protected, when it is shared, and how long it is kept.
            </p>
          </section>

          <section>
            <h2>Google user data we access</h2>
            <p>
              Quick Cards requests the non-sensitive Google Drive scope <code>drive.file</code>. That gives the
              app access only to files you choose with Google Picker or files you explicitly open with the app.
            </p>
            <p>For a spreadsheet you choose, the app may access:</p>
            <ul>
              <li>The spreadsheet file ID, title, and metadata needed to open it.</li>
              <li>Spreadsheet contents needed to run the app, including card text, settings, and review history.</li>
            </ul>
            <p>
              Quick Cards does not request broad access to all files in your Drive, and it does not request Gmail,
              contacts, calendar, or Google profile scopes for this feature.
            </p>
          </section>

          <section>
            <h2>How we use Google user data</h2>
            <p>Quick Cards uses Google user data to provide core flashcard functionality, including:</p>
            <ul>
              <li>Reading flashcard rows, app parameters, and review history from your spreadsheet</li>
              <li>Writing updates back to that spreadsheet, including history and parameters. Certain columns and sheets will be managed by the app</li>
              <li>Storing anonymized history to improve the scheduling model</li>
            </ul>
            <p>
              We do not use your data for advertising, and we do not sell your data.
            </p>
          </section>

          <section>
            <h2>What is stored and where</h2>
            <ul>
              <li>Your selected spreadsheet remains in your Google account.</li>
              <li>This app writes study data back to your spreadsheet, including flashcard state, parameters, and review history.</li>
              <li>
                The backend stores review-history rows in Google BigQuery, including spreadsheet ID,
                local user ID, and review-event fields such as timestamps, correctness, and model metadata.
              </li>
            </ul>
          </section>

          <section>
            <h2>Sharing, transfer, and disclosure</h2>
            <p>
              Quick Cards does not sell user data and does not share user data with data brokers,
              advertisers, or other unrelated third parties.
            </p>
            <p>Google user data may be disclosed only in the following limited cases:</p>
            <ul>
              <li>To Google Cloud and Firebase services used to run the app, such as Google Sheets API, Realtime Database, and BigQuery.</li>
              <li>To service providers as needed to host, secure, or maintain the app.</li>
              <li>When required by law, regulation, legal processes, or valid government requests.</li>
              <li>When reasonably necessary to detect, prevent, or address fraud, abuse, security, or technical issues.</li>
            </ul>
          </section>

          <section>
            <h2>Retention and deletion</h2>
            <ul>
              <li>Data written to your spreadsheet remains in your Google account until you edit or delete it.</li>
              <li>Recent-deck entries and the local app user ID remain in your browser until you clear browser storage.</li>
              <li>
                Anonymized review-history archive data is retained indefinitely, unless subject to a deletion request. 
              </li>
            </ul>
            <p>
              To request deletion of your data, reach out to us at the link delow.
            </p>
          </section>

          <section>
            <h2>Your choices</h2>
            <ul>
              <li>You can choose which spreadsheet to share with Quick Cards.</li>
              <li>You can stop using the app at any time.</li>
              <li>You can revoke the app&apos;s Google access in your Google account permissions.</li>
              <li>You can delete or modify spreadsheet data directly in Google Sheets.</li>
            </ul>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              Questions or deletion requests can be sent through{" "}
              <a href="hello@quickcards.xyz">hello@quickcards.xyz</a>.
            </p>
          </section>

          <section>
            <h2>How can I help?</h2>
            <p>
              Ideas, code, feature requests, and donations are always welcome. You can{" "}
              <a href="https://www.buymeacoffee.com/sifttrainer">buy me a coffee</a>,{" "}
              <a href="https://github.com/mchonofsky/flashcard-web-app">
                contribute on GitHub
              </a>
              , or{" "}
              <a href="https://www.markchonofsky.com">get in touch</a>.
            </p>
          </section>

          <Link className="privacy-back" to="/">
            Back to app
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
